const en = {
  '青瓷游戏官方充值中心': 'QCPLAY PAYMENT CENTER',
  '官方充值': 'Purchase',
  '我的订单': 'Orders',
  '联系客服': 'Customer Service',
  '您好，请登录': 'Log in',
  '注销': 'Log out',
  '最强蜗牛': 'Super Snail',
  '角色名称.游戏区组': 'Character Name & Game Server',
  '代钞': 'Voucher',
  '所选商品': 'Selected Item',
  '含': 'Item',
  '赠': 'Bonus',
  '等待支付结果完成中': 'Waiting for payment completion',
  '请稍后': 'Please wait for a while.',
  '代钞具体到账情况请到': 'Please check the purchased Vouchers',
  '游戏“背包”中进行查看': 'at your "Luggage" in the game.',
  '支付查询中': 'Verifying payment',
  '合计': 'Total',
  '充值说明': 'Notice',
  '立即支付': 'Pay Now',
  '青瓷游戏': 'QCPLAY',
  '官方充值中心': 'QCPLAY PAYMENT CENTER',
  '角色名称': 'Character Name',
  '游戏区组': 'Game Server',
  '充值账号': 'Recharge Account',
  '选择游戏区组': 'Choose Game Server',
  '苹果': 'iOS',
  '安卓': 'Android',
  '请选择区组': 'Choose Game Server',
  '请选择角色': 'Choose Character',
  '取消': 'Cancel',
  '确定': 'Confirm',
  '温馨提示': 'Friendly reminder',
  '游戏维护期间，暂时无法为您充值，给您造成的不便敬请谅解': 'You will not be able to recharge during the maintenance process. We apologize for the inconvenience caused',
  '好的': 'Confirm',
  '请选择商品类目': 'Choose item type',
  '请选择区组信息': 'Choose Game Server',
  '登录': 'Log in',
  '请先同意下方《青瓷游戏隐私政策》、《青瓷游戏用户服务协议》': 'Please agree to the QCPLAY Privacy Policy and End User License Agreement below',
  '邮箱信息填写错误': 'Incorrect Email',
  '登录成功': 'Logged in',
  '共': '',
  '条': ' in total',
  '选择需要充值的游戏': 'Choose a game to recharge',
  '您好，': 'Hello,',
  '暂无信息': 'No information yet',
  '请登录': ' Please Log in',
  '购买的代劵将反映在以下账号内，请确认内容无误': 'The voucher you purchased will be sent to the following account. Please confirm.',
  '支付成功': 'Payment Successful',
  '代钞具体到账情况请到游戏“背包”中进行查看': 'Please check the purchased Vouchers at your "Luggage" in the game.',
  '支付失败': 'Payment Failed',
  '请稍后再试': 'Please try again later',
  '查看订单': 'View the Order',
  '网络超时,请刷新页面或稍后重试': '接続がタイムアウトしましたページを更新するか、しばらく経ってから再度お試しください',
  '订单号': 'Order Number',
  '下单时间': 'Order Time',
  '开始日期': 'Start Date',
  '至': 'to',
  '结束日期': 'End Date',
  '没有更多了': 'No more',
  '全部游戏': 'All Games',
  '恭喜您复制成功，赶快去粘贴吧': 'Copy succeeded. You can paste it now.',
  '操作失败，请重试！': 'Operation failed. Please try again.',
  '遇到问题？': 'Report Issues',
  '邮箱账号登录': 'Login with Email Account',
  '请输入邮箱': 'Please enter your email',
  '请输入密码': 'Please enter your password',
  '查看如何拥有邮箱账号': 'Create an email account',
  '年龄认证': '年齢確認',
  '您的年龄决定了您每月可以购买的可计费项目的数量。': 'あなたの年齢によって1ケ月に購入できる有償アイテムの上限額が決まっています。',
  '请输入正确的出生日期。': '正しい生年月日を入力してください。',
  '设定的出生日期以后不能更改。': '設定した生年月日は後から変更できません',
  '16岁以下': '16歳未満',
  '16岁以上18岁未满': '16歳以上18歳未満',
  '18岁及以上': '18歳以上',
  '1个月': '1ヶ月',
  '无限制': '制限なし',
  '5000元以下': '5000円まで',
  '20000元以下': '20000円まで',
  '年': '年',
  '月': '月',
  '日': '日',
  '元': '円',
  '阅读并同意': 'Read and agree to',
  '《青瓷游戏隐私政策 》': 'QCPLAY Privacy Policy',
  '《青瓷游戏用户服务协议》': 'Terms of Use',
  '在进行支付时，由于支付渠道相关规则，可能出现超额提醒、限额提醒、风险提醒等，可切换支付方式后再次尝试': 'During the payment process, you may receive notifications such as overpayment reminders or risk warnings due to payment channel regulations. You can try again after switching payment methods.',
  '温馨提示：请您知悉，点击立即支付即视为您同意': 'Friendly reminder: Please be informed that clicking "Pay Now" will be considered as your agreement to the QCPLAY',
}

export default en